import apiHandler from "../core/apiHandler";

const inventoryEntryApi = apiHandler('inventory-entry');
export default inventoryEntryApi;
